import { Address } from "../Models";

let hcMap = [
  {
    insee: "22050",
    address: "56 R Chateaubriand",
    healthCenterName: "Ctre Hospitalier Dinan",
    finess: "220000095",
  },
  {
    insee: "22050",
    address: "56 R CHATEAUBRIAND",
    healthCenterName: "Ctre Hospitalier Dinan",
    finess: "220000095",
  },
  {
    insee: "22113",
    address: "BP 70348",
    healthCenterName: "CH LANNION SCANNER",
    finess: "220000368",
  },
  {
    insee: "22113",
    address: "R DU DR JACQUES FEUILLU",
    healthCenterName: "Polyclinique Du Tregor",
    finess: "220000111",
  },
  {
    insee: "22162",
    address: "36 chemin de kerpuns",
    healthCenterName: "Centre Hospitalier Paimpol",
    finess: "220000541",
  },
  {
    insee: "22187",
    address: "10 R Francois Jacob",
    healthCenterName: "Hopital Privé Des Cotes D'Armor",
    finess: "220022800",
  },
  {
    insee: "22187",
    address: "10 R FRANCOIS JACOB",
    healthCenterName: "Hopital Privé Des Cotes D'Armor",
    finess: "220022800",
  },
  {
    insee: "22278",
    address: "10 R Marcel Proust",
    healthCenterName: "Centre Hospitalier Yves Le Foll",
    finess: "220000012",
  },
  {
    insee: "29019",
    address: "2 Avenue Foch",
    healthCenterName: "Chru Brest",
    finess: "290000058",
  },
  {
    insee: "29019",
    address: "2 Avenue Foch",
    healthCenterName: "Chru Brest",
    finess: "290000058",
  },
  {
    insee: "35012",
    address: "2 R Hippolyte Fillioux",
    healthCenterName: "Hopital St Thomas De Villeneuve Bain",
    finess: "350000063",
  },
  {
    insee: "35051",
    address: "3 R Du Chene Germain",
    healthCenterName: "Hopital Prive Sevigne",
    finess: "350005146",
  },
  {
    insee: "35115",
    address: "133 R De La Foret",
    healthCenterName: "C.H Fougeres",
    finess: "350000154",
  },
  {
    insee: "35238",
    address: "320 Av Du General Patton",
    healthCenterName: "Polyclinique St Laurent",
    finess: "350002192",
  },
  {
    insee: "35238",
    address: "4 R Adolphe Leray",
    healthCenterName: "Clinique Saint Yves",
    finess: "350002200",
  },
  {
    insee: "35238",
    address: "54 R Saint Helier",
    healthCenterName: "Pole Mpr Saint Helier",
    finess: "350002564",
  },
  {
    insee: "35238",
    address: "4 Pl St Guenole",
    healthCenterName: "Clinique Mutualiste De La Sagesse",
    finess: "350000139",
  },
  {
    insee: "35238",
    address: "16 BD DE BULGARIE",
    healthCenterName: "CHU Rennes Hopital Sud",
    finess: "350007084",
  },
  {
    insee: "35278",
    address: "6 Bd De La Boutiere",
    healthCenterName: "Chp Saint Gregoire",
    finess: "350000121",
  },
  {
    insee: "35288",
    address: "1 R De La Marne",
    healthCenterName: "Centre Hospitalier Saint-Malo",
    finess: "350000147",
  },
  {
    insee: "35288",
    address: "1 R DE LA MARNE",
    healthCenterName: "Centre Hospitalier Saint-Malo",
    finess: "350000147",
  },
  {
    insee: "22278",
    address: "10 R Marcel Proust",
    healthCenterName: "CH Yves Le Foll",
    finess: "220000012",
  },
  {
    insee: "22362",
    address: "Allée Saint-Michel",
    healthCenterName: "SSR Hopital de Tréguier",
    finess: "220001259",
  },
  {
    insee: "22379",
    address: "BP 2",
    healthCenterName: "CENTRE REEDUC TRESTEL",
    finess: "220012884",
  },
  {
    insee: "35288",
    address: "1 Rue de la Maison Neuve",
    healthCenterName: "CLINIQUE DE L EMERAUDE SERVICE UROLOGIE",
    finess: "350000196",
  },
  {
    insee: "35288",
    address: "78 boulevard du rosais",
    healthCenterName: "service   psychiatrie   4",
    finess: "350000279",
  },
  {
    insee: "14118",
    address: "15 R Saint Ouen",
    healthCenterName: "Ets Public De Sante Mentale",
    finess: "140028721",
  },
  {
    insee: "14118",
    address: "Av Cote De Nacre",
    healthCenterName: "CHU Cote De Nacre - Caen",
    finess: "140000209",
  },
  {
    insee: "22172",
    address: "Tertre De Bran De Fer",
    healthCenterName: "La Maison De Velleda",
    finess: "220000467",
  },
  {
    insee: "22187",
    address: "17 R Dr Abel Violette",
    healthCenterName: "Centre Helio Marin",
    finess: "220000590",
  },
  {
    insee: "22070",
    address: "17 R De L'Armor",
    healthCenterName: "Centre Hospitalier Guingamp",
    finess: "220000343",
  },
  {
    insee: "22215",
    address: "6 R Du Bois Joli",
    healthCenterName: "Centre Soins De Suite Les Chatelets",
    finess: "220000475",
  },
  {
    insee: "22136",
    address: "38 R De Moncontour",
    healthCenterName: "Hop De Jour Loudeac",
    finess: "220012900",
  },
  {
    insee: "22136",
    address: "R De La Chesnaie",
    healthCenterName: "Chcb Site Loudeac",
    finess: "220000483",
  },
  {
    insee: "29046",
    address: "65 Av Ar Veret",
    healthCenterName: "Crf De Treboul",
    finess: "290003953",
  },
  {
    insee: "29232",
    address: "14 Av Yves Thepot",
    healthCenterName: "Chic Quimper",
    finess: "290000025",
  },
  {
    insee: "35238",
    address: "108 Av Du General Leclerc",
    healthCenterName: "C.H.  Guillaume Regnier Rennes",
    finess: "350000337",
  },
  {
    insee: "35238",
    address: "6 R De La Borderie",
    healthCenterName: "Clinique De L'Esperance",
    finess: "350002176",
  },
  {
    insee: "35238",
    address: "320 Av Du General Patton",
    healthCenterName: "Cim Laennec - Site Poly. St Laurent",
    finess: "350048369",
  },
  {
    insee: "35238",
    address: "41 Av Buttes De Coesmes",
    healthCenterName: "Centre Medical Et Pedagogique Beaulieu",
    finess: "350002234",
  },
  {
    insee: "35238",
    address: "8 Bd De Vitre",
    healthCenterName: "Centre Du Bois Perrin",
    finess: "350006839",
  },
  {
    insee: "35238",
    address: "320 Av General Patton",
    healthCenterName: "CHU Rennes Site Saint Laurent",
    finess: "350053013",
  },
  {
    insee: "35363",
    address: "La Chaussee",
    healthCenterName: "Clinique Philae",
    finess: "350044756",
  },
  {
    insee: "35055",
    address: "100 Av Andre Bonnin",
    healthCenterName: "Centre De Long Sejour  Chantepie",
    finess: "350005021",
  },
  {
    insee: "35136",
    address: "R Armand Jouault",
    healthCenterName: "CH De La Roche Aux Fées Janze",
    finess: "350000410",
  },
  {
    insee: "35188",
    address: "33 R Saint Nicolas",
    healthCenterName: "Centre Hospitalier Montfort-Sur-Meu",
    finess: "350000436",
  },
  {
    insee: "35047",
    address: "26 Ld Carce",
    healthCenterName: "Clinique Du Moulin",
    finess: "350002119",
  },
  {
    insee: "35049",
    address: "R Des Pres Bosgers",
    healthCenterName: "CH Des Pres Bosgers Cancale",
    finess: "350040499",
  },
  {
    insee: "35085",
    address: "Les Rivieres",
    healthCenterName: "Centre Local Hospitalier Saint Joseph",
    finess: "350000204",
  },
  {
    insee: "35297",
    address: "R De La Croix Duval",
    healthCenterName: "Centre Hospitalier St Meen Le Grand",
    finess: "350000451",
  },
  {
    insee: "35124",
    address: "29 R Saint Roch",
    healthCenterName: "Centre Hospitalier Grand-Fougeray",
    finess: "350000428",
  },
  {
    insee: "35288",
    address: "78 Bd Du Rosais",
    healthCenterName: "CH Saint Malo Site Du Rosais",
    finess: "350000279",
  },
  {
    insee: "35360",
    address: "30 Rte De Rennes",
    healthCenterName: "Centre Hospitalier   Vitre",
    finess: "350000188",
  },
  {
    insee: "35360",
    address: "45 R De Paris",
    healthCenterName: "Service De S.S.R. - CH Vitré",
    finess: "350016135",
  },
  {
    insee: "35113",
    address: "9 R De Fougeres",
    healthCenterName: "CH Des Marches De Bretagne - Antrain",
    finess: "350000444",
  },
  {
    insee: "35055",
    address: "100 Av Andre Bonnin",
    healthCenterName: "Pole Geriatrique Rennais",
    finess: "350005021",
  },
  {
    insee: "35236",
    address: "4 R De La Riaudaie",
    healthCenterName: "CH Redon Site Unite D'Hospit Lanrua",
    finess: "350051199",
  },
  {
    insee: "35236",
    address: "8 Av Etienne Gascon",
    healthCenterName: "Chirc Site Redon",
    finess: "350000162",
  },
  {
    insee: "35093",
    address: "1 R Henri Dunant",
    healthCenterName: "Hopital Arthur Gardiner",
    finess: "350000071",
  },
  {
    insee: "37261",
    address: "49 Bd Beranger",
    healthCenterName: "Chru Clocheville - Tours",
    finess: "370000499",
  },
  {
    insee: "44109",
    address: "1 Pl Alexis Ricordeau",
    healthCenterName: "CHU De Nantes :Site Hôtel-Dieu- Hme",
    finess: "440000271",
  },
  {
    insee: "44184",
    address: "11 Boulevard Georges Charpak",
    healthCenterName: "CHU De Saint Nazaire",
    finess: "440000016",
  },
  {
    insee: "50502",
    address: "45 R Du General Koenig",
    healthCenterName: "Polyclinique De La Manche - Saint-Lo",
    finess: "500000203",
  },
  {
    insee: "50502",
    address: "715 R Dunant",
    healthCenterName: "CH Memorial - Saint-Lo",
    finess: "500000450",
  },
  {
    insee: "50218",
    address: "1 R Jules Michelet",
    healthCenterName: "Crf Le Normandy - Granville",
    finess: "500000229",
  },
  {
    insee: "50484",
    address: "Place De Bretagne",
    healthCenterName: "CH De Saint Hilaire Du Harcouet",
    finess: "500000427",
  },
  {
    insee: "53130",
    address: "33 R Du Haut Rocher",
    healthCenterName: "Centre Hospitalier De Laval",
    finess: "530000264",
  },
  {
    insee: "53147",
    address: "229 Bd Paul Lintier",
    healthCenterName: "Centre Hospitalier Nord Mayenne",
    finess: "530000173",
  },
  {
    insee: "56260",
    address: "11 R Du Dr Joseph Audic",
    healthCenterName: "Hôpital Privé Océane",
    finess: "560008799",
  },
  {
    insee: "56260",
    address: "20 Bd General Maurice Guillaudot",
    healthCenterName: "CHBA Site De Vannes",
    finess: "560000127",
  },
  {
    insee: "56124",
    address: "4 Fg Saint Michel",
    healthCenterName: "Clinique Des Augustines",
    finess: "560000184",
  },
  {
    insee: "56162",
    address: "92 Rue de l'Anse du Stole",
    healthCenterName: "Ctre De Reed.Fonctionnelle De Kerpape",
    finess: "560002024",
  },
  {
    insee: "56121",
    address: "5 Av De Choiseul",
    healthCenterName: "Ghbs- Hôpital Du Scorff",
    finess: "560000135",
  },
  {
    insee: "56042",
    address: "Domaine de Korn er Houët",
    healthCenterName: "Centre De Soins De Suite Korn-Er-Houet",
    finess: "560003055",
  },
  {
    insee: "56007",
    address: "2 R Du Pratel",
    healthCenterName: "CHBA Site D'Auray",
    finess: "560000200",
  },
  {
    insee: "56165",
    address: "7 R Du Roi Arthur",
    healthCenterName: "Centre Hospitalier De Ploermel",
    finess: "560000192",
  },
  {
    insee: "56033",
    address: "R Abbe De La Valliere",
    healthCenterName: "Chirc Site Carentoir",
    finess: "560000473",
  },
  {
    insee: "61096",
    address: "32 Av Du Docteur Joly",
    healthCenterName: "Centre De Soins De Suite Le Parc",
    finess: "610780371",
  },
  {
    insee: "72181",
    address: "194 Av Rubillard",
    healthCenterName: "Centre Hospitalier Du Mans",
    finess: "720000033",
  },
  {
    insee: "72231",
    address: "Rte De Change",
    healthCenterName: "Centre Medical F.Gallouedec",
    finess: "720000413",
  },
  {
    insee: "85191",
    address: "Bd Stephane Moreau",
    healthCenterName: "Centre Hospitalier-Site La Roche/Yon",
    finess: "850000142",
  },
  {
    insee: "94028",
    address: "40 R De Mesly",
    healthCenterName: "Hu Henri Mondor  Chenevier Aphp",
    finess: "940100019",
  },
];

function init() {
  hcMap = hcMap.map((h) => {
    return {
      insee: h.insee,
      healthCenterName: h.healthCenterName.toLowerCase(),
      finess: h.finess,
      address: h.address,
    };
  });
}
init();
export function getHealthCenterFinessEventually(
  address: Address
): { finess: string; address: string } | undefined {
  const baseInsee = address.insee;
  const baseHcName = address.placeName.toLowerCase().trim();
  debugger;
  const match = hcMap.find((c) => {
    return (
      c.insee === baseInsee && c.healthCenterName.toLowerCase() === baseHcName
    );
  });
  if (match) {
    return { finess: match.finess, address: match.address };
  }
  return undefined;
}
